/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 180 cm man is around 75 kg by the Devine formula.`)
};

const es_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un hombre de 180 cm ronda los 75 kg según la fórmula de Devine.`)
};

const de_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 180 cm großer Mann liegt nach der Devine-Formel bei rund 75 kg.`)
};

const nl_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een man van 180 cm weegt volgens de Devine-formule ongeveer 75 kg.`)
};

const fr_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un homme de 180 cm pèse environ 75 kg selon la formule de Devine.`)
};

const it_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un uomo di 180 cm pesa circa 75 kg secondo la formula di Devine.`)
};

const pt_br2_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um homem de 180 cm tem cerca de 75 kg pela fórmula de Devine.`)
};

const pt_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um homem de 180 cm tem cerca de 75 kg segundo a fórmula de Devine.`)
};

const ja_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長180cmの男性はデバイン式でおよそ75kgです。`)
};

const zh_iw_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 Devine 公式，身高 180 厘米的男性理想体重约为 75 千克。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_ex1", locale)
	if (locale === "en") return en_iw_ex1(inputs)
	if (locale === "es") return es_iw_ex1(inputs)
	if (locale === "de") return de_iw_ex1(inputs)
	if (locale === "nl") return nl_iw_ex1(inputs)
	if (locale === "fr") return fr_iw_ex1(inputs)
	if (locale === "it") return it_iw_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_iw_ex1(inputs)
	if (locale === "pt") return pt_iw_ex1(inputs)
	if (locale === "ja") return ja_iw_ex1(inputs)
	return zh_iw_ex1(inputs)
};